/**
 * Ordered weekday keys for i18n lookup.
 * Index matches JavaScript's `Date.getUTCDay()` (0 = Sunday … 6 = Saturday).
 *
 * Usage: `translate.instant(\`common.weekdays.${WEEKDAY_KEYS[date.getUTCDay()]}\`)`
 */
export const WEEKDAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;

export type WeekdayKey = (typeof WEEKDAY_KEYS)[number];
